import React, { lazy, Suspense } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { HomePage } from "./pages/Home";
import Template from "./pages/Template";
import LppNew from "./pages/Lpp/LppNew"
import DtpNew from "./pages/Dtp/DtpNew";
import ExternalmaterialPdf from "./pages/ExternalMaterial/ExternalmaterialPdf"
import IdcardNew from "./pages/Idcard/IdcardNew";
import IdcardRelatorio from "./pages/Idcard/IdcardRelatorio";
import IdcardHistoryPage from "./pages/Idcard/IdcardHistory";
import { FunnelEdit } from "./pages/Funnel/FunnelEdit";
import FunnelRelatorio from "./pages/Funnel/FunnelRelatorio";
import FunnelRelatorioFabrica from "./pages/Funnel/FunnelRelatorioFabrica";
import TrainingMaterialNew from "./pages/TrainingMaterial/TrainingMaterialNew";
import LogPage from "./pages/LogPage/index";
import SupervisorPage from "./pages/SupervisorPage/index";
import AdminBI from "./pages/AdminBI/index";
import PendenciasBI from "./pages/AdminBI/pendencias";
import UXPage from "./pages/UXAnalytics/index";
import FactoryPage from "./pages/Assessment/factory";
import FactoryBIPage from "./pages/Assessment/factoryBI";
import FactoryBIReportPage from "./pages/Assessment/factoryBIReport";
import CompanyPage from "./pages/Assessment/company";
import StructureOrganizationPage from './pages/StructureOrganizationPage';
import AddStructureOrganizationPage from './pages/AddStructureOrganizationPage';
import NotAuthorizedPage from './pages/NotAuthorizedPage';
import TrainingReportPage from './pages/TrainingReport';
import TrainingMonthPage from './pages/TrainingMonth';
import ApproverReportPage from './pages/ApproverReport';
//import Buscador from './pages/Google';
import FarolPage from "./pages/FarolPage";
import ExportDMO from "./pages/Idcard/ExportDMO/index";
import Help from "./pages/Help";

const UserProfilepage = lazy(() =>
  import("./modules/UserProfile/UserProfilePage")
);

const Lpppage = lazy(() =>
  import("./pages/Lpp/LppPage")
);

const IdcardPage = lazy(() =>
  import("./pages/Idcard/IdcardPage")
);

const ApprovalnoBI = lazy(() =>
  import("./pages/ApproverReport/index1")
);

const GeneralReportnoBI = lazy(() =>
  import("./pages/GeneralReport/index")
);

const FunnelTablenoBI = lazy(() =>
  import("./pages/FunnelTable/index")
);

const RolloutPage = lazy(() =>
    import("./pages/Rollout/index")
);

const biTicket = lazy(() => import('./pages/BiTickets'));

const LogsnoBI = lazy(() =>
  import("./pages/LogPage/index1")
);


const Dtppage = lazy(() =>
  import("./pages/Dtp/DtpPage")
);

const TrainingMaterialPage = lazy(() =>
  import("./pages/TrainingMaterial/TrainingMaterialPage")
);

const ApprovalFlowPage = lazy(() =>
  import("./pages/ApprovalFlow/ApprovalFlowPage")
)

const TrainingPage = lazy(() =>
  import("./pages/Training/TrainingRegister")
)

const GalleryPage = lazy(() =>
  import("./pages/Gallery/GalleryPage")
)

const FollowApprovalPage = lazy(() =>
  import("./pages/ApprovalFlow/FollowApprovalView")
)

const FunnelPage = lazy(() =>
  import("./pages/Funnel/FunnelPage")
)

const StandardPage = lazy(() =>
  import("./pages/Standard/StandardPage")
)

const StandardAdminPage = lazy(() =>
  import("./pages/Standard/Admin/StandardAdminPage")
)

const TrainingEditPage = lazy(() =>
    import("./pages/Standard/Admin/TrainingEditPage")
)


const MyTrainingPage = lazy(() =>
  import('./pages/Training/MyTraining')
)

const MyTrainingPagenoBI = lazy(() =>
  import('./pages/TrainingnoBI/MyTrainingnoBI')
)

const PagesForSupervisor = lazy(() =>
  import('./pages/SupervisorPageTable/index')
)




const ContributorRoute = lazy(() =>
  import('./pages/Users')
)

const ContributorsNationalRoute = lazy(() =>
  import('./pages/Users/indexNational')
)

const ProductPage = lazy(() =>
  import('./pages/Product/Page')
)

const ExternalTrainingPage = lazy(() =>
  import('./pages/ExternalTraining/Page')
)

const ExternalDocumentPage = lazy(() =>
    import('./pages/ExternalDocument/Page')
)

const ExternalDocumentPilarPage = lazy(() =>(
  import ('./pages/ExternalDocumentPilar/Page')
))

const MaterialGTAPage = lazy(() =>
    import('./pages/MaterialGTA/Page')
)

const CostCenterPage = lazy(() =>
    import('./pages/CostCenter/Page')
)

const HelpIndex = lazy(() =>
    import('./pages/Help/index')
)

const DefectCategoryPage = lazy(() =>
  import('./pages/DefectCategory/Page')
)

const DefectTypePage = lazy(() =>
  import('./pages/DefectType/Page')
)

const Buscador = lazy(() =>
    import('./pages/Google')
)

const ExternalDocumentList = lazy(() =>( import('./pages/ExternalDocumentList/Page')))

export default function BasePage() {

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/home" />
        }
              <ContentRoute path="/home" component={HomePage} />
              <ContentRoute path="/product" roleLevel="responsavel ferramenta" component={ProductPage} />
              <ContentRoute path="/externaldocumentqms" roleLevel="responsavel ferramenta" component={ExternalDocumentPage} />
              <ContentRoute path="/externaldocumentlist" roleLevel="convidado" component={ExternalDocumentList} />
              <ContentRoute path="/ExternalDocumentPilarPage" roleLevel="responsavel ferramenta" component={ExternalDocumentPilarPage} />
              <ContentRoute path="/externaltraining" roleLevel="responsavel ferramenta" component={ExternalTrainingPage} />
              <ContentRoute path="/materialgta" roleLevel="responsavel ferramenta" component={MaterialGTAPage} />
              <ContentRoute path="/costcenter" roleLevel="admin fabrica" component={CostCenterPage} />
              <ContentRoute path="/defectcategory" roleLevel="responsavel ferramenta" component={DefectCategoryPage} />
              <ContentRoute path="/defecttype" roleLevel="responsavel ferramenta" component={DefectTypePage} />
              <ContentRoute path="/template" roleLevel="admin corporativo" component={Template} />
              <ContentRoute path="/factoryBIassessment" roleLevel="convidado" component={FactoryBIPage} />
              <ContentRoute path="/factoryBIRelatorio" roleLevel="convidado" component={FactoryBIReportPage} />
              <ContentRoute path="/factoryassessment" roleLevel="convidado" component={FactoryPage} />
              <ContentRoute path="/approverreport" roleLevel="responsavel ferramenta" component={ApprovalnoBI} />
              <ContentRoute path="/GeneralReportnoBI" roleLevel="admin fabrica" component={GeneralReportnoBI} />
              <ContentRoute path="/PagesForSupervisor" roleLevel="admin fabrica" component={PagesForSupervisor} />
              <ContentRoute path="/FunnelTablenoBI" roleLevel="admin fabrica" component={FunnelTablenoBI} />
              <ContentRoute path="/LogsnoBI" roleLevel="responsavel ferramenta" component={LogsnoBI} />
              <ContentRoute path="/HelpIndex" roleLevel="convidado" component={HelpIndex} />
              <ContentRoute path="/companyassessment" roleLevel="admin fabrica" component={CompanyPage} />
              <ContentRoute path="/lpp/new/:id" roleLevel="convidado" component={LppNew} />
              <ContentRoute path="/lpp" roleLevel="convidado" component={Lpppage} />
              <ContentRoute path="/idcard/new/:id" roleLevel="convidado" component={IdcardNew} />
              <ContentRoute path="/idcard" roleLevel="convidado" component={IdcardPage} /> 
              <ContentRoute path="/idcard/ExportDMO" roleLevel="convidado" component={ExportDMO} />
              <ContentRoute path="/idcard/History" roleLevel="responsavel ferramenta" component={IdcardHistoryPage} />
              <ContentRoute path="/idcard/relatorio/:option/:filter" roleLevel="responsavel ferramenta" component={IdcardRelatorio} /> 
              <ContentRoute path="/trainingmaterial/new/:id" roleLevel="convidado" component={TrainingMaterialNew} />
              <ContentRoute path="/trainingmaterial" roleLevel="convidado" component={TrainingMaterialPage} /> 
              <ContentRoute path="/standard" roleLevel="convidado" component={StandardPage} />
              <ContentRoute path="/stdadmin" roleLevel="responsavel ferramenta" component={StandardAdminPage} />
              <ContentRoute path="/edittraining/:identifier" roleLevel="convidado" component={TrainingEditPage} />
              <ContentRoute path="/training-admin" roleLevel="responsavel ferramenta" component={TrainingReportPage} />
              <ContentRoute path="/training-month" roleLevel="responsavel ferramenta" component={TrainingMonthPage} />
              <ContentRoute path="/approverreportBI" roleLevel="responsavel ferramenta" component={ApproverReportPage} />
              <ContentRoute path="/StructureOrganizations" roleLevel="admin fabrica" component={StructureOrganizationPage} />
              <ContentRoute path="/StructureOrganization/add/:id" roleLevel="admin fabrica" component={AddStructureOrganizationPage} />
              <ContentRoute path="/StructureOrganization/edit/:id" roleLevel="admin fabrica" component={AddStructureOrganizationPage} />
              <ContentRoute path="/funnel" roleLevel="convidado" component={FunnelPage} />
              <ContentRoute path="/funnel/new/:id" roleLevel="convidado" component={FunnelEdit} />
              <ContentRoute path="/funnel/relatorio" roleLevel="convidado" component={FunnelRelatorio} /> 
              <ContentRoute path="/funnel/relatfabrica/:params" roleLevel="convidado" component={FunnelRelatorioFabrica} />
              <ContentRoute path="/dtp/new/:id" roleLevel="convidado" component={DtpNew} />
              <ContentRoute path="/dtp" roleLevel="convidado" component={Dtppage} />
              <ContentRoute path="/approval" roleLevel="convidado" component={ApprovalFlowPage} />
              <ContentRoute path="/gallery" roleLevel="admin fabrica" component={GalleryPage} />
              <ContentRoute path="/logs" roleLevel="responsavel ferramenta" component={LogPage} />
              <ContentRoute path="/painelsupervisor" roleLevel="convidado" component={SupervisorPage} />
              <ContentRoute path="/paineladmin" roleLevel="responsavel ferramenta" component={AdminBI} />
              <ContentRoute path="/pendenciaadmin" roleLevel="responsavel ferramenta" component={PendenciasBI} />
              <ContentRoute path="/UXAnalitycs" roleLevel="responsavel ferramenta" component={UXPage} />
              { /*<ContentRoute path="/imports" roleLevel="admin fabrica"  component={ImportsPage} />*/}
              <ContentRoute path="/user-profile" roleLevel="convidado" component={UserProfilepage} />                            
              <ContentRoute path="/user/training" roleLevel="convidado"  component={MyTrainingPage} />              
              <ContentRoute path="/training-adminNOBI" roleLevel="admin fabrica"  component={MyTrainingPagenoBI} />              
              <Route path="/contributors" roleLevel="responsavel ferramenta" component={ContributorRoute} />
              <Route path="/contributorsNational" roleLevel="admin corporativo" component={ContributorsNationalRoute} />
              <ContentRoute path="/training/standard/:id" roleLevel="convidado"  component={TrainingPage} />
              <ContentRoute path="/training/externalmaterial/:id" roleLevel="convidado"  component={TrainingPage} />
              <ContentRoute path="/followapproval/:id" roleLevel="convidado" component={FollowApprovalPage} />
              <ContentRoute path="/buscador" roleLevel="convidado" component={Buscador} />
              <ContentRoute path="/Farol/:id/:activityId" roleLevel="convidado" component={FarolPage} />
              <ContentRoute path="/externalmaterial/:id" component={ExternalmaterialPdf} /> 
              <ContentRoute path="/rollout" roleLevel="admin corporativo" component={RolloutPage} />
              <ContentRoute path="/biTicket" roleLevel="admin fabrica" component={biTicket} />
              <ContentRoute path="/not-authorized" component={NotAuthorizedPage} />              
              <Redirect exact to="/not-authorized" />
      </Switch>
    </Suspense>
  );
}
